@if (params()?.value) {
  <div
    [ngClass]="{ 'translated-cell': true, withStatusPadding: $safeNavigationMigration(params()?.cellOptions?.withStatusPadding) }"
    [ngStyle]="translateStyle()"
  >
    {{
      translateKey() +
        (params()?.cellOptions?.applyLowerCase ? $safeNavigationMigration(params()?.value?.toLowerCase()) : $safeNavigationMigration(params()?.value))
        | translate
    }}
  </div>
} @else {
  <div class="translated-cell" [ngStyle]="translateStyle()">-</div>
}
